<script>
import IconList from '@img/icons/material-duotone/list.svg?inline';
import IconHistory from '@img/icons/material-duotone/history.svg?inline';
import IconContract from '@img/icons/material-duotone/data-object.svg?inline';
import UiTabs from '~/components/UiTabs.vue';
import TxHistory from '~/components/address/TxHistory.vue';
import TabContractSources from '~/components/address/Verifier/Verifier.vue';
import NftHistory from './Tabs/NftHistory.vue';

export default {
    props: {
        isActive: Boolean,
        address: {
            type: String,
            required: true,
        },
    },

    render(createComponent) {
        return createComponent(UiTabs, {
            class: 'card card--tabbed',
            props: {
                tabs: this.tabs,
                changeUrlHash: true,
            },
            on: this.$listeners, // passthru listeners from parent
        });
    },

    computed: {
        tabs() {
            const props = { address: this.address };
            const key = this.address; // keepalive key

            return [{
                key: 'history',
                text: this.$t('nft.item.history_tx'),
                icon: IconHistory,
                content: {
                    key, props,
                    eager: true,
                    component: NftHistory,
                },
            }, {
                key: 'transactions',
                text: this.$t('nft.item.recent_tx'),
                icon: IconList,
                content: {
                    key, props,
                    eager: true,
                    component: TxHistory,
                },
            }, {
                key: 'source',
                text: this.$t('address.tab_contract'),
                icon: IconContract,
                content: {
                    key,
                    component: TabContractSources,
                    props: {
                        address: this.address,
                        isActive: true,
                    },
                },
            }];
        },
    },
};
</script>
